// Ateliers à deux animateur·rice·s (DECISIONS §36) : la phrase et le badge que
// la gestion voit sur une demande, selon le mode choisi dans Administration ›
// Co-animation et selon que l'autre personne est absente aussi ce jour-là.
import type { CoanimationDemande, ModeCoanimation } from '../../types';

import { dePersonne } from '../messages/format';
export const LIBELLE_MODE_COANIMATION: Record<ModeCoanimation, string> = {
  binome: 'Binôme',
  alternance: 'Alternance',
};

export const EXPLICATION_MODE_COANIMATION: Record<ModeCoanimation, string> = {
  binome: 'Les deux animent ensemble : une seule absence ne demande pas de remplacement, il en faut un quand les deux sont absent·e·s.',
  alternance: "L'un·e ou l'autre anime selon la semaine : à chaque absence, la gestion vérifie qui anime ce jour-là.",
};

export type NiveauAvis = 'ok' | 'attention' | 'info';

export interface AvisCoanimation {
  niveau: NiveauAvis;
  /** Badge court (liste des demandes). */
  badge: string;
  /** Titre et phrase de la carte (fiche demande). */
  titre: string;
  texte: string;
}

/** Ce qu'il faut dire à la gestion ; null si l'atelier n'a qu'une personne. */
export function avisCoanimation(c: CoanimationDemande | null | undefined): AvisCoanimation | null {
  if (!c) return null;
  const noms = c.animateurs.map((a) => a.nom).join(' et ');
  const autre = c.autre;
  if (c.mode == null) {
    return {
      niveau: 'info', badge: 'Deux animateur·rice·s',
      titre: 'Atelier à deux animateur·rice·s',
      texte: `${noms} sont inscrit·e·s sur ce créneau. Binôme ou alternance n'est pas encore défini (Administration › Co-animation) : la demande suit la règle habituelle.`,
    };
  }
  if (!autre) {
    return {
      niveau: 'info', badge: LIBELLE_MODE_COANIMATION[c.mode],
      titre: `Atelier en ${c.mode === 'binome' ? 'binôme' : 'alternance'}`,
      texte: `Créneau ${dePersonne(noms)}. La personne absente n'est aucune des deux.`,
    };
  }
  if (c.mode === 'binome') {
    return autre.absent
      ? {
        niveau: 'ok', badge: 'Binôme : les deux absent·e·s',
        titre: 'Binôme : les deux sont absent·e·s',
        texte: `${autre.nom} est aussi absent·e ce jour-là : la séance doit être remplacée.`,
      }
      : {
        niveau: 'attention', badge: `Binôme : ${autre.nom} est là`,
        titre: 'Binôme : a priori pas de remplacement',
        texte: `${autre.nom} anime aussi cette séance et n'est pas absent·e ce jour-là : une seule absence ne demande pas de remplacement. Validez l'absence sans remplaçant·e, ou écartez la demande.`,
      };
  }
  return autre.absent
    ? {
      niveau: 'ok', badge: 'Alternance : les deux absent·e·s',
      titre: 'Alternance : les deux sont absent·e·s',
      texte: `${autre.nom} est aussi absent·e ce jour-là : quelle que soit la personne prévue, la séance doit être remplacée.`,
    }
    : {
      niveau: 'attention', badge: 'Alternance : à vérifier',
      titre: 'Alternance : qui anime ce jour-là ?',
      texte: `Cet atelier est animé à tour de rôle avec ${autre.nom}, et rien n'indique qui anime cette semaine. Si c'est ${autre.nom}, il n'y a rien à remplacer : écartez la demande. Sinon, envoyez-la.`,
    };
}

export const CLASSE_BADGE_AVIS: Record<NiveauAvis, string> = {
  ok: 'badge badge-ok',
  attention: 'badge badge-warn',
  info: 'badge badge-plain',
};
